/**
 * AddBulk Configuration
 * Constants and configuration objects for bulk upload functionality
 */

import { SelectOption } from "components/dropdown/Dropdown";
import { UploadData, PAGES } from "./AddBulk.types";

/**
 * Survey action options
 */
export const SURVEY_ACTIONS: SelectOption[] = [
  { label: "Dispatch", value: "Dispatch" },
  { label: "Recall", value: "Recall" },
];

/**
 * Default initial values for the form
 */
export const DEFAULT_INITIAL_VALUES: UploadData = {
  csvFile: null,
};

/**
 * Entity type configuration mapping
 * Maps each entity type to its specific field names and requirements
 */
export const ENTITY_TYPE_CONFIG: Record<
  PAGES,
  {
    fileFieldName: string;
    requiresContactType?: boolean;
    requiresSurveyData?: boolean;
  }
> = {
  [PAGES.SITE]: {
    fileFieldName: "CsvFile",
  },
  [PAGES.ITEM]: {
    fileFieldName: "BulkItemFile",
  },
  [PAGES.CONTACT]: {
    fileFieldName: "CsvFile",
    requiresContactType: true,
  },
  [PAGES.ASSET]: {
    fileFieldName: "CsvFile",
  },
  [PAGES.CATALOGUE_ITEMS]: {
    fileFieldName: "CsvFile",
  },
  [PAGES.USER]: {
    fileFieldName: "CsvFile",
  },
  [PAGES.SURVEY]: {
    fileFieldName: "CsvFile",
    requiresSurveyData: true,
  },
};
